import { useEffect, useState } from "react";

function formatCountdown(secs) {
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function useOtpBlockCountdown(store) {
  const blockExpiresAt = store((s) => s.blockExpiresAt);
  const clearOtpBlock = store((s) => s.clearOtpBlock);

  const isBlocked = !!blockExpiresAt && blockExpiresAt > Date.now();

  const [secondsLeft, setSecondsLeft] = useState(() =>
    blockExpiresAt
      ? Math.max(0, Math.ceil((blockExpiresAt - Date.now()) / 1000))
      : 0,
  );

  useEffect(() => {
    if (blockExpiresAt) {
      setSecondsLeft(Math.max(0, Math.ceil((blockExpiresAt - Date.now()) / 1000)));
    }
  }, [blockExpiresAt]);

  useEffect(() => {
    if (!isBlocked) return;
    const interval = setInterval(() => {
      const remaining = Math.max(0, Math.ceil((blockExpiresAt - Date.now()) / 1000));
      setSecondsLeft(remaining);
      if (remaining === 0) clearOtpBlock();
    }, 1000);
    return () => clearInterval(interval);
  }, [isBlocked, blockExpiresAt, clearOtpBlock]);

  return { isBlocked, countdown: formatCountdown(secondsLeft) };
}
